const module = { name: 'swig/lib/filters', exports: {} }; const exports = module.exports;



import { swig_lib_utils as utils } from '@grins/fd-modules/splits/require-core';



import { swig_lib_dateFormatter as dateFormatter } from '@grins/fd-modules/splits/require-core';



import { swig_lib_DateZ as swig_lib_DateZ_DateZ } from '@grins/fd-modules/splits/require-core';

const { DateZ } = swig_lib_DateZ_DateZ;
function iterateFilter(input) {
    const self = this;
    const out = {};
    if (utils.isArray(input)) {
        return utils.map(input, function () {
            return self.apply(null, arguments);
        });
    }
    if (typeof input === 'object') {
        utils.each(input, function (value, key) {
            out[key] = self.apply(null, arguments);
        });
        return out;
    }
    return;
}
function exportsAddslashes(input) {
    const out = iterateFilter.apply(exportsAddslashes, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.replace(/\\/g, '\\\\').replace(/'/g, '\\\'').replace(/"/g, '\\"');
}
exports.addslashes = exportsAddslashes;
function exportsCapitalize(input) {
    const out = iterateFilter.apply(exportsCapitalize, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.toString().charAt(0).toUpperCase() + input.toString().substr(1).toLowerCase();
}
exports.capitalize = exportsCapitalize;
exports.date = function (input, format, offset, abbr) {
    const l = format.length;
    const date = new DateZ(input);
    let cur;
    let i = 0;
    let out = '';
    if (offset) {
        date.setTimezoneOffset(offset, abbr);
    }
    for (i; i < l; i += 1) {
        cur = format.charAt(i);
        if (cur === '\\') {
            i += 1;
            out += (i < l) ? format.charAt(i) : cur;
        }
        else if (dateFormatter.hasOwnProperty(cur)) {
            out += dateFormatter[cur](date, offset, abbr);
        }
        else {
            out += cur;
        }
    }
    return out;
};
exports.default = function (input, def) {
    return (typeof input !== 'undefined' && (input || typeof input === 'number')) ? input : def;
};
function forceEscape(input, type) {
    let out = iterateFilter.apply(forceEscape, arguments);
    let inp = input;
    let i = 0;
    let code;
    if (out !== undefined) {
        return out;
    }
    if (typeof input !== 'string') {
        return input;
    }
    out = '';
    switch (type) {
        case 'js':
            inp = inp.replace(/\\/g, '\\u005C');
            for (i; i < inp.length; i += 1) {
                code = inp.charCodeAt(i);
                if (code < 32) {
                    code = code.toString(16).toUpperCase();
                    code = (code.length < 2) ? '0' + code : code;
                    out += '\\u00' + code;
                }
                else {
                    out += inp[i];
                }
            }
            return out.replace(/&/g, '\\u0026')
                .replace(/</g, '\\u003C')
                .replace(/>/g, '\\u003E')
                .replace(/'/g, '\\u0027')
                .replace(/"/g, '\\u0022')
                .replace(/=/g, '\\u003D')
                .replace(/-/g, '\\u002D')
                .replace(/;/g, '\\u003B');
        default:
            return inp.replace(/&(?!amp;|lt;|gt;|quot;|#39;)/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
    }
}
exports.escape = forceEscape;
exports.e = forceEscape;
exports.first = function (input) {
    if (typeof input === 'object' && !utils.isArray(input)) {
        const keys = utils.keys(input);
        return input[keys[0]];
    }
    if (typeof input === 'string') {
        return input.substr(0, 1);
    }
    return input[0];
};
exports.groupBy = function (input, key) {
    if (!utils.isArray(input)) {
        return input;
    }
    const out = {};
    utils.each(input, (value) => {
        if (!value.hasOwnProperty(key)) {
            return;
        }
        const keyname = value[key];
        const newValue = utils.extend({}, value);
        delete newValue[key];
        if (!out[keyname]) {
            out[keyname] = [];
        }
        out[keyname].push(newValue);
    });
    return out;
};
exports.join = function (input, glue) {
    if (utils.isArray(input)) {
        return input.join(glue);
    }
    if (typeof input === 'object') {
        const out = [];
        utils.each(input, (value) => {
            out.push(value);
        });
        return out.join(glue);
    }
    return input;
};
function exportsJson(input, indent) {
    return JSON.stringify(input, null, indent || 0);
}
exports.json = exportsJson;
exports.json_encode = exportsJson;
exports.last = function (input) {
    if (typeof input === 'object' && !utils.isArray(input)) {
        const keys = utils.keys(input);
        return input[keys[keys.length - 1]];
    }
    if (typeof input === 'string') {
        return input.charAt(input.length - 1);
    }
    return input[input.length - 1];
};
exports.length = function (input) {
    if (typeof input === 'object' && !utils.isArray(input)) {
        const keys = utils.keys(input);
        return keys.length;
    }
    if (input.hasOwnProperty('length')) {
        return input.length;
    }
    return '';
};
function exportsLower(input) {
    const out = iterateFilter.apply(exportsLower, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.toString().toLowerCase();
}
exports.lower = exportsLower;
exports.raw = Object.assign(x => x, { safe: true });
exports.replace = function (input, search, replacement, flags) {
    const r = new RegExp(search, flags);
    return input.replace(r, replacement);
};
exports.reverse = function (input) {
    return exportsSort(input, true);
};
exports.safe = Object.assign(x => x, { safe: true });
function exportsSort(input, reverse) {
    let out, clone;
    if (utils.isArray(input)) {
        clone = utils.extend([], input);
        out = clone.sort();
    }
    else {
        switch (typeof input) {
            case 'object':
                out = utils.keys(input).sort();
                break;
            case 'string':
                out = input.split('');
                if (reverse) {
                    return out.reverse().join('');
                }
                return out.sort().join('');
        }
    }
    if (out && reverse) {
        return out.reverse();
    }
    return out || input;
}
exports.sort = exportsSort;
function exportsStriptags(input) {
    const out = iterateFilter.apply(exportsStriptags, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.toString().replace(/(<([^>]+)>)/ig, '');
}
exports.striptags = exportsStriptags;
function exportsTitle(input) {
    const out = iterateFilter.apply(exportsTitle, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.toString().replace(/\w\S*/g, str => str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
}
exports.title = exportsTitle;
exports.uniq = function (input) {
    if (!input || !utils.isArray(input)) {
        return '';
    }
    const result = [];
    utils.each(input, (v) => {
        if (result.indexOf(v) === -1) {
            result.push(v);
        }
    });
    return result;
};
function exportsUpper(input) {
    const out = iterateFilter.apply(exportsUpper, arguments);
    if (out !== undefined) {
        return out;
    }
    return input.toString().toUpperCase();
}
exports.upper = exportsUpper;
function exportsUrl_encode(input) {
    const out = iterateFilter.apply(exportsUrl_encode, arguments);
    if (out !== undefined) {
        return out;
    }
    return encodeURIComponent(input);
}
exports.url_encode = exportsUrl_encode;
exports.url_decode = function exportsUrl_decode(input) {
    const out = iterateFilter.apply(exportsUrl_decode, arguments);
    if (out !== undefined) {
        return out;
    }
    return decodeURIComponent(input);
};
export default module.exports;